import {
    CLEAR_GANTT_PROJECT,
    FETCH_GANTT_PROJECT,
    FETCH_GANTT_PROJECT_FAIL,
    IS_LOADING_GANTT_PROJECT
} from "../actionTypes";

const initialState = {
    id: 0,
    name: "",
    startDate: "",
    endDate: "",
    actions: [],
    isLoading: false,
    status:0,
}

const ganttProjectReducer = (state = initialState, action) => {
    switch (action.type) {
        case IS_LOADING_GANTT_PROJECT:
            return {
                ...state,
                isLoading: true,
            }

        case FETCH_GANTT_PROJECT:
            return {
                ...state,
                id: action.payload.id,
                name: action.payload.name,
                startDate: action.payload.startDate,
                endDate: action.payload.endDate,
                actions: action.payload.actions,
                status: 'OK',
                isLoading: false,
            }

        case FETCH_GANTT_PROJECT_FAIL:
            return {
                ...state,
                status: 'FAIL'
            }

        case CLEAR_GANTT_PROJECT:
            return initialState

        default:
            return {
                ...state
            }
    }
}

export default ganttProjectReducer